import { useRef } from 'react';

export const useTour = (isAdmin = false) => {
  const changeThemeButtonRef = useRef(null);
  const profileRef = useRef(null);
  const menuRef = useRef(null);
  const logoRef = useRef(null);
  const exitButtonRef = useRef(null);

  const steps = [
    {
      title: 'Изменение темы',
      description:
        'Переключайте интерфейс между светлой и тёмной темами для эффективной работы в любых условиях, включая ночь и низкую видимость.',
      target: () => changeThemeButtonRef.current,
    },
    {
      title: 'Профиль',
      description:
        'Ваш позывной — основной идентификатор в системе. Для удобства и быстрой визуальной идентификации вы можете загрузить фото профиля.',
      target: () => profileRef.current,
    },
    {
      title: 'Меню',
      description:
        'Быстрый доступ к ключевым разделам для управления средствами, данными и взаимодействием в едином информационном контуре.',
      target: () => menuRef.current,
    },
    isAdmin
      ? {
          title: 'Журнал обновлений',
          description:
            'Нажмите на логотип для перехода в журнал обновлений. Здесь отображаются все изменения и улучшения, доступные в текущей версии сервера.',
          target: () => logoRef.current,
        }
      : null,
    {
      title: 'Выход',
      description: 'Завершение работы с сервером.',
      target: () => exitButtonRef.current,
    },
  ].filter(item => item);

  return {
    changeThemeButtonRef,
    profileRef,
    menuRef,
    logoRef,
    exitButtonRef,
    steps,
  };
};
